export const CONTACT_ASSOCIATION = 'CONTACT_ASSOCIATION';